import type { NewRelicBrowserAgent } from "@/lib/newrelic/types";

declare global {
  interface Window {
    newrelic?: NewRelicBrowserAgent;
  }
}

export const noticeBrowserError = (error: Error): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.newrelic?.noticeError(error);
};
